"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "spot-role-cont" };
const _hoisted_2 = { class: "form-padding" };
const _hoisted_3 = {
    for: "input-date",
    class: "font-spot-label"
};
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "form-padding" };
const _hoisted_6 = {
    for: "input-time",
    class: "font-spot-label"
};
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "form-padding" };
const _hoisted_9 = {
    for: "input-name",
    class: "font-spot-label"
};
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "form-padding" };
const _hoisted_12 = {
    for: "input-payment",
    class: "font-spot-label"
};
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "spot-modal-btn" };
const Modal_vue_1 = __importDefault(require("../../../vue/Modal.vue"));
const types_1 = require("../../types");
const common_1 = require("../../../common/common");
const timeZones_1 = __importDefault(require("../../../common/timeZones"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'VerificationModal',
    props: {
        isNoShow: { type: Boolean },
        form: {},
        spotworkerName: {},
        totalPayment: {},
        isLoading: { type: Boolean }
    },
    emits: ["close-verify-modal", "emit-error", "emit-status"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        function handleClose() {
            emits("close-verify-modal");
        }
        async function onVerify() {
            if (props.isLoading) {
                return;
            }
            try {
                const status = !props.isNoShow ? types_1.SpotShiftStatusType.COMPLETED : types_1.SpotShiftStatusType.NO_SHOW;
                emits("emit-status", status);
            }
            catch (err) {
                emits("emit-error", err);
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                class: "spotwork-verify-modal",
                onCloseModal: _cache[0] || (_cache[0] = ($event) => (handleClose())),
                "has-title-divider": true,
                "has-footer-divider": false
            }, {
                "header-title": (0, vue_2.withCtx)(() => [...(_cache[1] || (_cache[1] = [
                        (0, vue_2.createElementVNode)("span", { class: "header-text" }, "支払い確認", -1 /* CACHED */)
                    ]))]),
                content: (0, vue_2.withCtx)(() => [
                    _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("small", null, "以下の内容をご確認ください。変更が必要な場合は、oplusへお問い合わせください。", -1 /* CACHED */)),
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("label", _hoisted_3, [
                                _cache[2] || (_cache[2] = (0, vue_2.createTextVNode)(" 日付 ", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("input", {
                                    disabled: "",
                                    value: (0, vue_2.unref)(common_1.jpDateString)(new Date(__props.form.date), (0, vue_2.unref)(timeZones_1.default).ASIA_TOKYO),
                                    class: "form-input form-input-spot br-5",
                                    type: "text",
                                    name: "date",
                                    id: "input-date"
                                }, null, 8 /* PROPS */, _hoisted_4)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("label", _hoisted_6, [
                                _cache[3] || (_cache[3] = (0, vue_2.createTextVNode)(" 時間 ", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("input", {
                                    disabled: "",
                                    value: `${__props.form.from} ~ ${__props.form.to}`,
                                    class: "form-input form-input-spot br-5",
                                    type: "text",
                                    name: "time",
                                    id: "input-time"
                                }, null, 8 /* PROPS */, _hoisted_7)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("label", _hoisted_9, [
                                _cache[4] || (_cache[4] = (0, vue_2.createTextVNode)(" 名前 ", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("input", {
                                    disabled: "",
                                    value: __props.spotworkerName,
                                    class: "form-input form-input-spot br-5",
                                    type: "text",
                                    name: "name",
                                    id: "input-name"
                                }, null, 8 /* PROPS */, _hoisted_10)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("label", _hoisted_12, [
                                _cache[5] || (_cache[5] = (0, vue_2.createTextVNode)(" 支払い ", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("input", {
                                    disabled: "",
                                    value: __props.isNoShow ? '0' : `¥${__props.totalPayment}`,
                                    class: "form-input form-input-spot br-5",
                                    type: "text",
                                    name: "payment",
                                    id: "input-payment"
                                }, null, 8 /* PROPS */, _hoisted_13)
                            ])
                        ])
                    ])
                ]),
                "footer-btn": (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_14, [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)([{ loading: __props.isLoading }, "oplus-modal-btn oplus-cancel-btn"]),
                            onClick: handleClose
                        }, "キャンセル", 2 /* CLASS */),
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)([{ loading: __props.isLoading }, "oplus-modal-btn oplus-alt-confirm-btn spot-work-color"]),
                            onClick: onVerify
                        }, "確認", 2 /* CLASS */)
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
